import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { placements } from '@popperjs/core';
import FeedbackButton from './FeedbackButton';

const HomepageUserGuide = () => {
  const { t, i18n } = useTranslation();
  const [run, setRun] = useState(false); // Controls whether the guide runs
  const [stepIndex, setStepIndex]=useState(0);
  const [showWelcomeCard, setShowWelcomeCard] = useState(false); // Show/Hide the welcome card
  useEffect(() =>{
    const hasSeenGuide =localStorage.getItem('hasSeenUserGuide');
    if (!hasSeenGuide){
        setShowWelcomeCard(true); //show the welcome Card for the first-time user
    }

  }, [])

  const steps = [
    {
      target: '.logo', // Target the logo
      disableBeacon: true,
      
      content: (
        <div>
          <p style={{textAlign:"center"}}>{t('userguide.logo_description')}</p>
        </div>
      ),
    },
    {
      target: '#language-selector', // Target the language selector
      content: (
        <div>
          <p style={{textAlign:"center"}}>{t('userguide.language_description')}</p>
        </div>
      ),
    },
    
    {
      target: '#interactivemap', // Target the interactive map link
      content: (
        <div>
          <p style={{textAlign:"center"}}>{t('userguide.interactivemap_description')}</p>
        </div>
      ),
    },
    {
      target: '#geospatial_governance', // Target the geospatial governance link
      content: (
        <div>
          <p style={{textAlign:"center"}}>{t('userguide.geospatial_governance_description')}</p>
        </div>
      ),
    },
    {
        target: '#geospatial_applications', // Target the geospatial governance link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.geospatial_applications_description')}</p>
          </div>
        ),
      },
      {
        target: '#digital_library', // Target the geospatial governance link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.digital_library_description')}</p>
          </div>
        ),
      },
      

      
      {
        target: '#more', // Target the geospatial governance link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.more_description')}</p>
          </div>
        ),
      },
    
    {
        target: '#datarequest', // Target the geospatial incidences link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.datarequest_description')}</p>
          </div>
        ),
      },
      {
        target: '#opendata', // Target the geospatial incidences link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.opendata_description')}</p>
          </div>
        ),
      },
      {
        target: '#geospatialIncidence', // Target the geospatial incidences link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.geospatialIncidence_description')}</p>
          </div>
        ),
      },
      {
        target: '#officialMap', // Target the geospatial incidences link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.officialMap')}</p>
          </div>
        ),
      },
      {
        target: '#KSAMAP', // Target the KSAMAP link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.KSAMAP_description')}</p>
          </div>
        ),
      },
      {
        target: '#Geocatalog', // Target the KSAMAP link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.Geocatalog_description')}</p>
          </div>
        ),
      },
      {
        target: '#feedback_page', // Target the geospatial governance link
        content: (
          <div>
            <p style={{textAlign:"center"}}>{t('userguide.feedback_page')}</p>
          </div>
        ),
      },
      {
        target: '#Guide', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.guide')}</p>
          </div>
        ),
      },
     
      {
        target: '#geonames_description', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.geonames_description')}</p>
          </div>
        ),
      },
      {
        target: '#sdg_description', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.sdg_description')}</p>
          </div>
        ),
      },
      {
        target: '#geodesy_description', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.geodesy_description')}</p>
          </div>
        ),
      },
      {
        target: '#digitaltwin_description', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.digitaltwin_description')}</p>
          </div>
        ),
      },
      {
        target: '#statistics', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.statistics_description')}</p>
          </div>
        ),
      },
      {
        target: '#opendata_todownload', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.opendata_todownload')}</p>
          </div>
        ),
      },
      {
        target: '#opendata_todisplay', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.opendata_todisplay')}</p>
          </div>
        ),
      },
     
      {
        target: '#Opendata_item', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.Opendata_item')}</p>
          </div>
        ),
      },
      {
        target: '#Opendata_description', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.Opendata_description')}</p>
          </div>
        ),
      },
      {
        target: '#Opendata_format', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.Opendata_format')}</p>
          </div>
        ),
      },
      {
        target: '#Opendata_details', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.Opendata_details')}</p>
          </div>
        ),
      },
    {
        target: '#feedback', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.feedback')}</p>
          </div>
        ),
      },
      
      {
        target: '#terms_of_use', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.terms_of_use')}</p>
          </div>
        ),
      },
      {
        target: '#privacyPolicy', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.privacypolicy')}</p>
          </div>
        ),
      },
      {
        target: '#FAQ', // Target the KSAMAP link
        content: (
          <div>
            <p>{t('userguide.FAQ')}</p>
          </div>
        ),
      },
  ];

  const startGuide = () => {
    localStorage.setItem('hasSeenUserGuide', 'true');
    setShowWelcomeCard(false); // Hide the welcome card
    setStepIndex(0);
    setRun(true); // Start the user guide
  };

  const skipGuide = () => {
    localStorage.setItem('hasSeenUserGuide', 'true');
    setShowWelcomeCard(false); // Just hide the welcome card
    setRun(false);
  };

  const reopenGuide =()=> {
    setStepIndex(0);
    setRun(true); //restart the guide
  };

  return (
    <>
     {/* Reopen Guide Button using the existing Button */}
     <div className="fixed-buttons" >  
      
        
      <button className="btn btn-primary feedback-btn" 
      onClick={reopenGuide}
      style={{marginTop:'65px'}}>
        <svg className="svg" fill="currentColor" height="100%" viewBox="0 0 16 16" width="100%" xmlns="http://www.w3.org/2000/svg"id="Guide">
          <path d="M15 3.6L11.4 0H2v16h13zM14 15H3V1h7v4h4zm0-11h-3V1h.31L14 3.69z"></path>
        </svg>
      </button>
    
  
</div>
      {/* Welcome Card */}
      {showWelcomeCard && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2000,
            background: '#fff',
            borderRadius: '10px',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            padding: '20px',
            width: '300px',
            textAlign: 'center',
          }}
        >
          <h4>{t('userguide.welcome_title')}</h4>
          <p>{t('userguide.welcome_message')}</p>
          <div style={{ marginTop: '20px' }}>
            <button
              onClick={startGuide}
              style={{
                padding: '10px 20px',
                background: '#01715d',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                margin: '10px',
              }}
            >
              {t('userguide.start_button')}
            </button>
            <button
              onClick={skipGuide}
              style={{
                padding: '10px 20px',
                background: '#ccc',
                color: '#01715d',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              {t('userguide.skip_button')}
            </button>
          </div>
        </div>
      )}
      


      {/* Joyride for the user guide */}
      <Joyride
        steps={steps}
        run={run}
        setStepIndex={setStepIndex}
        continuous={true} // Enable Next button navigation
        scrollToFirstStep={true}
        showSkipButton={true} // Add a Skip button
        callback={({status}) => {
            if (status==='finished' || status==='skipped') {
                setRun(false)
            }
        }}
        locale={{
          next: t('userguide.next'),
          back: t('userguide.back'),
          skip: t('userguide.skip'),
          last:t('userguide.last'),
        }}
        styles={{
          options: {
            arrowColor: '#fff',
            backgroundColor: '#fff',
            primaryColor: '#007bff',
            textColor: '#333',
            zIndex: 1000,
            color: '#01715d',
          },
          tooltip: {
            borderRadius: '1rem',
            padding: '10px',
            boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
            fontSize:'1rem',
            maxWidth:'15rem',
            textAlign:'center'
          },

         
          buttonBack: {
            display: 'inline-block',
            marginRight: i18n.language === 'ar' ? '0' : '10px', // Reverse margins for RTL
            marginLeft: i18n.language === 'ar' ? '10px' : '0',
            color: '#01715d',
            fontSize:'0.7rem'


          },
          buttonNext: {
            display: 'inline-block',
            backgroundColor: '#01715d',
            fontSize:'0.7rem'

          },
          buttonSkip: {
            display: 'inline-block',
            marginRight: i18n.language === 'ar' ? '0' : '10px', // Reverse margins for RTL
            marginLeft: i18n.language === 'ar' ? '10px' : '0',
            fontSize:'0.7rem'

          },
        }}
      />
     
    </>
  );
};

export default HomepageUserGuide;
